import { render, staticRenderFns } from "./role-edit.vue?vue&type=template&id=40c698ba"
import script from "./role-edit.vue?vue&type=script&lang=js"
export * from "./role-edit.vue?vue&type=script&lang=js"
import style0 from "./role-edit.vue?vue&type=style&index=0&id=40c698ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports